export default () => ({
  conference: {},
  chatLogs: []
})
